// extracted by mini-css-extract-plugin
export default {"wrapper":"BackLink_wrapper__3bqN4"};